import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"
const pathBase = API_ROUTES.SETTINGS.COMPANY

export function createCompany(data) {
    return apiHelper({ method: "post", path: pathBase.CREATE, data })
}

export function editCompany(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteCompany(companyId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { companyId } })
}

export function getCompanyList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
